const config = {
  endpoint: process.env.REACT_APP_VAY_BACKEND_URL
    ? process.env.REACT_APP_VAY_BACKEND_URL
    : "https://myvay.dev.qilab.it/myvaysvc/api",
  DEV: !process.env.NODE_ENV || process.env.NODE_ENV === "development",
};

export default config;
